import { getLog } from './debugLog';

const YOUTUBE_RESOURCES = /youtube|ytimg|googlevideo|ggpht|gstatic/i;

export function environmentInfo() {
  const nav = typeof navigator !== 'undefined' ? navigator : {};
  return {
    build: process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA || 'unknown',
    url: window.location.href,
    origin: window.location.origin,
    referrer: document.referrer || '',
    referrerPolicy: document.referrerPolicy || '(browser default)',
    isSecureContext: window.isSecureContext,
    topLevel: window.top === window,
    userAgent: nav.userAgent,
    language: nav.language,
    cookiesEnabled: nav.cookieEnabled,
    doNotTrack: nav.doNotTrack || null,
    globalPrivacyControl: nav.globalPrivacyControl || null,
    brave: Boolean(nav.brave),
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    timezoneOffsetMinutes: new Date().getTimezoneOffset(),
    ytApiLoaded: Boolean(window.YT && window.YT.Player)
  };
}

// What the browser fetched from YouTube's hosts, and how long it took
export function youtubeResourceTimings() {
  try {
    return performance.getEntriesByType('resource')
      .filter((entry) => YOUTUBE_RESOURCES.test(entry.name))
      .slice(0, 60)
      .map((entry) => ({
        url: entry.name.slice(0, 160),
        type: entry.initiatorType,
        ms: Math.round(entry.duration),
        bytes: entry.transferSize
      }));
  } catch (error) {
    return [];
  }
}

// What /api/playlist says right now, exactly as the page would see it
export async function probePlaylistService(fetchFn = (...args) => fetch(...args)) {
  try {
    const response = await fetchFn('/api/playlist', { headers: { Accept: 'application/json' } });
    const text = await response.text();
    return { status: response.status, ok: response.ok, contentType: response.headers.get('content-type'), body: text.slice(0, 6000) };
  } catch (error) {
    return { error: String(error && error.message ? error.message : error) };
  }
}

export async function buildReport({ kind, results, extra } = {}) {
  return {
    report: 'nicole.click youtube diagnostics',
    kind: kind || 'page',
    generatedAt: new Date().toISOString(),
    environment: environmentInfo(),
    playlistService: await probePlaylistService(),
    youtubeResources: youtubeResourceTimings(),
    ...(results ? { results } : {}),
    ...(extra || {}),
    log: getLog()
  };
}

export const reportToText = (report) => JSON.stringify(report, null, 2);

export function downloadReport(report, name = 'nicole-fm-youtube-report') {
  const stamp = new Date().toISOString().replace(/[:.]/g, '-');
  const blob = new Blob([reportToText(report)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${name}-${stamp}.json`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function copyReport(report) {
  const text = reportToText(report);
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    return false;
  }
}
